import { render, staticRenderFns } from "./GBMembers.vue?vue&type=template&id=b25c37fe&"
import script from "./GBMembers.vue?vue&type=script&lang=js&"
export * from "./GBMembers.vue?vue&type=script&lang=js&"
import style0 from "./GBMembers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports